import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import {
  RescheduleHistory,
  RescheduleHistoryReqBody,
} from '../../../types/history';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useRescheduleHistoryActions = (
  whichAction: 'rescheduleHistoryList' | 'clientRescheduleHistory' | '',
  historyType?: 'assigned_by' | 'assigned_to' | 'all',
  clientId?: number
) => {
  // query function to fetch reschedule history list declared here
  const getRescheduleHistoryList = useQuery({
    queryKey: ['reschedule-history-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<RescheduleHistory>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        `/appointment/reschedule/history/list/${historyType}/`
      );

      return response.data;
    },

    ...returnQueryConfig(
      whichAction === 'rescheduleHistoryList' && !!historyType
    ),
  });

  // query function to get reschedule history by client id declared here
  const getRescheduleHistoryByClientId = useQuery({
    queryKey: ['reschedule-history-by-associate-id'],
    queryFn: async (): Promise<AcademiaResponse<Array<RescheduleHistory>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/client/reschedule/appointment/history',
        { params: { client_id: clientId } }
      );

      return response.data;
    },

    ...returnQueryConfig(
      whichAction === 'clientRescheduleHistory' && !!clientId
    ),
  });

  // mutation function to create new reschedule history declared here
  const createNewRescheduleHistory = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: RescheduleHistoryReqBody;
    }): Promise<AcademiaResponse<RescheduleHistory>> => {
      const response = await getPrivateAxiosInstance('appointment').post(
        '/appointment/reschedule/history/create/',
        body
      );

      return response.data;
    },
  });

  const updateRescheduleHistoryStatus = useMutation({
    mutationFn: async ({
      historyId,
      body,
    }: {
      historyId: number;
      body: {
        appointment_request: number;
        reschedule_status: 'pending' | 'confirmed' | 'rejected';
      };
    }): Promise<AcademiaResponse<RescheduleHistory>> => {
      const response = await getPrivateAxiosInstance('appointment').patch(
        `/appointment/reschedule/history/${historyId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  return {
    getRescheduleHistoryList,
    getRescheduleHistoryByClientId,
    createNewRescheduleHistory,
    updateRescheduleHistoryStatus,
  };
};

export default useRescheduleHistoryActions;
